import React, { useEffect, useState, memo } from "react";
import useSelectedFinYear from "../../../utils/selectedFinyear";
import CustomDate from "../../corpaction/corpActionMaster/date/CustomDate";
import CustomDate1 from "../../corpaction/corpActionMaster/date/CustomDate1";
import MobileFilter from "../../../components/ui/MobileFilter";

const MasterDropDown = ({ setFilter, isFilter, setIsFilter }) => {
  let [value, setValue] = useState();
  const [handleSetValue, setHandleSetValue] = useState();
  const [selectedValues, setSelectedValues] = useState({});

  const { startFinDate, currentDateStr } = useSelectedFinYear();

  
  useEffect(() => {
    setFilter({
      status: value,
      ...handleSetValue,
    });
  }, [value, handleSetValue]);

  const handleApplyFilters = (selectedValues) => {
    setFilter({
      bookclose_recorddate: selectedValues?.date_from,
      nse_exdate: selectedValues?.date_to,
      status: selectedValues?.status,
    });
  };

  const couponMasterFilters = [
    {
      name: "date_from",
      label: "Start Date",
      type: "date from",
    },
    {
      name: "date_to",
      label: "End Date",
      type: "date to",
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "both", label: "Both" },
        { value: "Active", label: "Active" },
        { value: "Inactive", label: "Inactive" },
      ],
    },
  ];

  return (
    <div className=" flex w-full items-baseline gap-2 pt-[10px]">
      <div className="mb-8 flex w-full flex-wrap items-baseline gap-4 max-sm:hidden">
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>Start Date</label>
            <CustomDate
              className={"bg-[#F7F7F7]"}
              initialValue={handleSetValue?.bookclose_recorddate}
              setHandleSetValue={setHandleSetValue}
              max={
                handleSetValue?.ex_to ? handleSetValue?.ex_to : currentDateStr
              }
            />
          </div>
        </div>
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>End Date</label>
            <CustomDate1
              className={"bg-[#F7F7F7]"}
              initialValue={handleSetValue?.ex_to}
              setHandleSetValue={setHandleSetValue}
              handleValue={handleSetValue}
              min={
                handleSetValue?.bookclose_recorddate
                  ? handleSetValue?.bookclose_recorddate
                  : startFinDate
              }
            />
          </div>
        </div>
        <div className=" flex w-[200px] items-stretch gap-4 text-neutral-600">
          <div className="flex w-[200px]  flex-col gap-3 ">
            <label>Status</label>
            <select
              onChange={(e) => setValue(e.target.value)}
              className={`w-full bg-[#F7F7F7] py-[10px] text-[14px] text-[#868686]  focus:outline-none`}
            >
              <option value={"both"}>Both</option>
              <option value={"Active"}>Active</option>
              <option value={"Inactive"}>Inactive</option>
            </select>
          </div>
        </div>
      </div>
      {isFilter && (
        <MobileFilter
          filters={couponMasterFilters}
          onApply={handleApplyFilters}
          onClose={() => setIsFilter(false)}
          isFilter={isFilter}
          setSelectedValues={setSelectedValues}
          selectedValues={selectedValues}
          nofinyearDate={true}
        />
      )}
    </div>
  );
};

export default memo(MasterDropDown);
